import { useState } from "react"
import BtnApply from "../components/btnApply"
// import logo from "../assets/logo.svg"
import Drawer from "./drawer"
import { Link } from "react-router-dom"

const Navbar = () => {

    const [open, setOpen] = useState(false)
    const [navStyle, setNavStyle] = useState("")
    const [isScroll, setIsScroll] = useState(false)

    // set background to white when scroll
    const changeBackground = () => {
        if (window.scrollY >= 1) {
            setNavStyle("bg-white shadow-sm  text-primary ")
            setIsScroll(true)
        } else {
            setNavStyle("")
            setIsScroll(false)
        }
    }
    window.addEventListener('scroll', changeBackground)
    const hamburgerStyle = isScroll ? "text-gray-500  border-gray-500 hover:text-blue-800 hover:border-blue-300" : "text-white border-white"
    const btnStyle = isScroll ? "border-gray-800 text-gray-800" : ""
    const logo = isScroll ? "/assets/logo_w-1.png" : "/assets/logo_bw-1.png"
    return (
        <div className={`z-50 fixed  top-0 w-full ${navStyle}  transition-all duration-300 ease-in-out`}>
            <div className={`w-full flex items-center justify-center px-4 `} >
                <nav className="flex w-full items-center justify-between py-1 ">

                    <div className="flex w-full flex-1  items-center self-center justify-between space-x-9 ">
                        <div className="flex ">
                            <button
                                 aria-label="hamburger"
                                className={`flex items-center   navbar-burger ${hamburgerStyle}`}
                                onClick={() => setOpen(true)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"

                                    fill="currentColor"
                                    className="bi bi-list size-8 md:size-10"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                                    />
                                </svg>
                            </button>
                        </div>

                        <Link to={"/"}>
                            <img src={logo} loading="lazy" width={130} height={130} className="w-20 2xl:w-32 transition-all duration-500" alt="logo" />
                        </Link>

                        <BtnApply css={btnStyle} isScroll={isScroll} />


                    </div>

                </nav>


            </div>
            <Drawer open={open} handleOpen={setOpen} />
        </div>

    )
}

export default Navbar